import type { FC, ReactNode } from 'react';
import styles from './ContractsList.module.scss';
import { TitleRow } from 'components/TitleRow';
import { ContractItem } from 'components/ContractItem';
import { ContractType } from 'redux/Api/contractsApi/type';
import { Nothing } from 'components/Nothing';

interface ContractsListTypes {
  data?: ContractType[];
  intersectionComponent: ReactNode;
  hidePerformer?: boolean;
  hideTitleRow?: boolean;
}

export const ContractsList: FC<ContractsListTypes> = ({
  data,
  intersectionComponent,
  hidePerformer = false,
  hideTitleRow,
}) => {
  const dataTitle = [
    '№',
    'Дата начала',
    'Дата окончания',
    'Подписано заказчиком',
    'Подписано исполнителем',
    ...(!hidePerformer ? ['Исполнитель'] : []),
    'Договор',
    'Лимит, ₽',
    'Гражданство',
    'МВД',
    '',
  ];

  return (
    <div className={styles.root}>
      {!hideTitleRow && (
        <TitleRow data={dataTitle} title={'contracts'} hidePerformer={hidePerformer} />
      )}
      {data?.length ? (
        <div className={styles.window}>
          {data.map((contract) => (
            <ContractItem
              key={contract.id}
              contract={contract}
              hidePerformer={hidePerformer}
            />
          ))}
          {intersectionComponent}
        </div>
      ) : (
        <Nothing style={{ height: '640px' }} title='Ничего не найдено' />
      )}
    </div>
  );
};
